<template>
    <div class="row g-6 g-xl-9">
        <div class="col-12 col-md-12 col-xl-12">
            <IndexInterno :disciplina="disciplina" :modal_cadastro="modal_cadastro" :perfis="perfis" />
        </div>
    </div>
</template>

<script lang="ts">
import IndexInterno from "./_Index.vue"
import { Options, Vue } from "vue-class-component";
import { namespace } from 'vuex-class';
const authStore = namespace('auth');
import { Prop } from 'vue-property-decorator';

@Options({
    name: "DisciplinaSegundaChamada",
    components: { IndexInterno },
})
export default class DisciplinaSegundaChamada extends Vue {
    @authStore.Getter
    public perfis!: any

    @Prop() readonly disciplina!: any

    public modal_cadastro;

    created() {
        this.modal_cadastro = 'kt_cadastrar_disciplina_segunda_chamada';
    }
}
</script>
